module.exports = __webpack_public_path__ + "img/Project-Aerial-Day-RV.a955c18.png";